// extracted by mini-css-extract-plugin
export default {"overlay":"QoWwF1","opened":"wiuAD2"};